import React from "react";
import PropTypes from 'prop-types'


export default class Menu extends React.Component {
    constructor(props, ...args) {
            super(props, ...args)
            this.state = {
                visible: this.props.visible
            }
    }

    toggleMenu=()=> {
        this.setState({
            visible: false,
        })
    }
    getStyle=()=>{
       const styles={
           base: {
               width:0,
           },
           visible: {
               width:"100%",
           }
       }
       return this.props.visible ? styles.visible : styles.base;
    }

    render () {
        return (
            <div style={this.getStyle()} className="menu">
                <button className="close-btn" onClick={this.props.onChange}>&times;</button>
                <div className="menu-items" >
                    {this.props.children}
                </div>  
            </div>);
    }
};

Menu.propTypes = {
    visible: PropTypes.bool,
    onChange: PropTypes.func,
}


// WEBPACK FOOTER //
// ./src/templates/Menu.js